<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<el-dialog append-to-body class="custom-nested-dialog request-type-field-dialog" :title="title" :before-close="handleBeforeCloseDialog" :visible.sync="isDialogActiveLocal">
		<PerfectScrollbar>
			<form @submit.prevent="" autocomplete="off" class="form request-type-field-dialog__form p-6">
				<div class="mb-5">
					<legend>{{ $t("FieldConfig.Name") }}<span class="text-danger">&nbsp;*</span>:</legend>
					<cbs-input
						name="name"
						class="inputx w-full"
						:placeholder="`${$t('Actions.Input')} ${$t('FieldConfig.Name').toLowerCase()}`"
						v-model="value.title"
						:data-vv-as="$t('FieldConfig.Name')"
						v-validate="'required'"
					/>
					<span class="text-danger text-sm">{{ errors.first("name") }}</span>
				</div>

				<div class="my-5">
					<legend>{{ $t("FieldConfig.Type") }}<span class="text-danger">&nbsp;*</span>:</legend>
					<v-select
						name="type"
						label="name"
						v-validate="'required'"
						:value="value.control"
						:reduce="option => option.id"
						:options="requestTypeControls"
						:data-vv-as="$t('FieldConfig.Type')"
						:placeholder="`${$t('Actions.Choose')} ${$t('FieldConfig.Type').toLowerCase()}`"
						@input="handleChangeControl"
					>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
					<span class="text-danger text-sm">{{ errors.first("type") }}</span>
				</div>

				<div class="field-config my-5" v-if="value.control">

					<div class="text-config" v-if="value.control === $constant.request.control.autofill">
						<autofill-field-config v-model="attributesValue" :fieldOptions="requestTypeControlsRelation" />
					</div>

					<div class="text-config" v-if="value.control === $constant.request.control.text">
						<legend>{{ $t("FieldConfig.TextLength") }}:</legend>
						<text-field-config v-model="attributesValue" />
					</div>

					<div class="textarea-config" v-if="value.control === $constant.request.control.textarea">
						<legend>{{ $t("FieldConfig.DisplayType") }}<span class="text-danger">&nbsp;*</span>:</legend>
						<textarea-field-config v-model="attributesValue" />
					</div>

					<div class="number-config" v-if="value.control === $constant.request.control.number">
						<legend>{{ $t("FieldConfig.DisplayType") }}<span class="text-danger">&nbsp;*</span>:</legend>
						<number-field-config v-model="attributesValue" />
					</div>

					<div class="relation-config" v-if="value.control === $constant.request.control.relation">
						<legend>{{ $t("FieldConfig.RelationModel") }}<span class="text-danger">&nbsp;*</span>:</legend>
						<relation-field-config v-model="attributesValue" />
					</div>

					<div class="datetime-config" v-if="value.control === $constant.request.control.datetime">
						<legend>{{ $t("FieldConfig.DisplayType") }}<span class="text-danger">&nbsp;*</span>:</legend>
						<datetime-field-config v-model="attributesValue" />
					</div>

					<div class="calculator-config" v-if="value.control === $constant.request.control.calculator">
						<legend class="flex justify-between items-center">
							<div>{{ $t("FieldConfig.Calculation") }}<span class="text-danger">&nbsp;*</span>:</div>
							<cbs-hint :data="$t('FieldConfig.CalculationHint')" />
						</legend>
						<calculator-field-config v-model="attributesValue" :listFields="filterNumnerFormFields" />
					</div>

					<div class="add-options-config" v-if="[$constant.request.control.radio, $constant.request.control.checkbox, $constant.request.control.dropdown].includes(value.control)">
						<legend>{{ $t("FieldConfig.ListOptions") }}<span class="text-danger">&nbsp;*</span>:</legend>
						<add-options v-model="attributesValue" :isEditable="isEditable" :inputPlaceholder="`${$t('Actions.Input')} ${$t('FieldConfig.OptionContent').toLowerCase()}...`" />
					</div>

					<div class="repeater-config" v-if="value.control === $constant.request.control.repeater">
						<repeater-field-config name="repeater" v-validate="'required'" v-model="childValue" :data-vv-as="$t('FieldConfig.ListFields')" />
						<span class="text-danger text-sm">{{ errors.first("repeater") }}</span>
					</div>

					<div class="label-config" v-if="value.control === $constant.request.control.label">
						<legend>{{ $t("FieldConfig.LabelContent") }}<span class="text-danger">&nbsp;*</span>:</legend>
						<label-field-config v-model="attributesValue" />
					</div>
				</div>

				<div class="flex items-center my-5">
					<vs-switch color="success" v-model="isRequiredValue" />
					<span class="ml-3">{{ $t("FieldConfig.IsRequired") }}</span>
				</div>

				<div class="flex items-center my-5">
					<vs-switch color="success" v-model="isEnableValue" />
					<span class="ml-3">{{ $t("FieldConfig.IsEnable") }}</span>
				</div>

				<!-- is readable for type Number and calculator -->
				<div class="flex items-center my-5" v-if="value.control === $constant.request.control.number || value.control === $constant.request.control.calculator">
					<vs-switch color="success" v-model="isReadable" />
					<span class="ml-3">{{ $t("FieldConfig.isReadable") }}</span>
				</div>

				<!-- is readable for type calculator -->
				<div class="flex items-center my-5" v-if="value.control === $constant.request.control.calculator">
					<vs-switch color="success" v-model="showAsText" />
					<span class="ml-3">{{ $t("FieldConfig.showAsText") }}</span>
				</div>

				<!-- Calculator Type -->
				<div class="my-5" v-if="value.control === $constant.request.control.calculator">
					<legend>{{ $t("FieldConfig.Calculation") }}:</legend>
					<div class="flex mt-3">
						<vs-radio class="w-1/2" v-model="calculatorType" vs-value="sum">{{ $t("Summary") }}</vs-radio>
						<vs-radio class="w-1/2" v-model="calculatorType" vs-value="average">{{ $t("Average") }}</vs-radio>
					</div>
				</div>

				<div class="flex">
					<vs-checkbox v-model="value.description.enable" color="primary" class="ml-0">
						<span class="ml-5">{{ $t("FieldConfig.Info") }}</span>
					</vs-checkbox>
				</div>

				<div class="mt-5" v-if="value.description.enable">
					<legend>{{ $t("FieldConfig.Info") }}:</legend>
					<cbs-textarea v-model="value.description.value" :placeholder="`${$t('Actions.Input')} ${$t('FieldConfig.Info').toLowerCase()}`" />

					<div class="mt-5">
						<legend>{{ $t("FieldConfig.InfoPosition") }}:</legend>
						<div class="mt-2 flex flex-wrap justify-between">
							<vs-radio class="mb-2 md:mb-0" vs-name="info-position" v-model="value.description.position" :vs-value="$constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM">
								<div>{{ $t("FieldConfig.Bottom") }}</div>
							</vs-radio>

							<vs-radio class="mb-2 md:mb-0" vs-name="info-position" v-model="value.description.position" :vs-value="$constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP">
								<div>{{ $t("FieldConfig.Top") }}</div>
							</vs-radio>

							<vs-radio class="mb-2 md:mb-0" vs-name="info-position" v-model="value.description.position" :vs-value="$constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON">
								<div>{{ $t("FieldConfig.Icon") }}</div>
							</vs-radio>
						</div>
					</div>
				</div>
			</form>
		</PerfectScrollbar>

		<div slot="footer" class="flex items-center sm:px-12 justify-center">
			<vs-button @click.stop="submitData" class="w-full sm:w-2/5 font-bold">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";

import vSelect from "vue-select";
import AddOptions from "./AddOptions";
import TextFieldConfig from "./TextFieldConfig";
import LabelFieldConfig from "./LabelFieldConfig";
import CbsHint from "@/components/cbs-hint/CbsHint";
import NumberFieldConfig from "./NumberFieldConfig";
import DatetimeFieldConfig from "./DatetimeFieldConfig";
import TextareaFieldConfig from "./TextareaFieldConfig";
import RelationFieldConfig from "./RelationFieldConfig";
import RepeaterFieldConfig from "./RepeaterFieldConfig";
import CalculatorFieldConfig from "./CalculatorFieldConfig";
import AutofillFieldConfig from "./AutofillFieldConfig";

export default {
	name: "ConfigFieldDialog",
	provide() {
		return { parentValidator: this.$validator };
	},
	components: {
		vSelect,
		CbsHint,
		AddOptions,
		TextFieldConfig,
		LabelFieldConfig,
		NumberFieldConfig,
		DatetimeFieldConfig,
		TextareaFieldConfig,
		RelationFieldConfig,
		RepeaterFieldConfig,
		CalculatorFieldConfig,
		AutofillFieldConfig
	},
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => {
				return (
					_.has(prop, "id") &&
					_.has(prop, "title") &&
					_.has(prop, "control") &&
					_.has(prop, "children") &&
					_.has(prop, "attributes") &&
					_.has(prop, "is_optional") &&
					_.has(prop, "description")
				);
			}
		},
		isDialogActive: {
			type: Boolean,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		formFields: {
			type: Array,
			required: true,
			validator: prop => prop.every(item => _.has(item, "id") && _.has(item, "title") && _.has(item, "control"))
		},
		isEditable: {
			type: Boolean,
			default: false
		}
	},
	emits: {
		closeDialog: {
			required: true
		},
		onSubmit: {
			required: true
		}
	},
	data() {
		return {
			initFormData: {},
			isFormDirty: false
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
		requestTypeControls() {
			return this.$constant.DYNAMIC_FORM_FIELD_CONTROLS || [];
		},
		requestTypeControlsRelation() {
			let controls = [];
			if (this.formFields) {
				this.formFields.forEach(field => {
					if (field.control == this.$constant.request.control.relation && field.enable) {
						let attributes = field.attributes;
						if (typeof attributes === 'string') {
							attributes = JSON.parse(attributes);
							if (attributes && !attributes.is_multiple) {
								controls.push({id: field.id, name: field.title});
							}
						}
					}
				})
			}
			return controls;
		},
		childValue: {
			get() {
				return this.value.children;
			},
			set(val) {
				this.$emit("input", { ...this.value, children: val });
			}
		},
		isRequiredValue: {
			get() {
				return !this.value.is_optional;
			},
			set(val) {
				this.$emit("input", { ...this.value, is_optional: !val });
			}
		},
		isEnableValue: {
			get() {
				return this.value.enable;
			},
			set(val) {
				this.$emit("input", { ...this.value, enable: val });
			}
		},
		isReadable: {
			get() {
				return this.attributesValue.is_readable;
			},
			set(val) {
				this.$emit("input", { ...this.value, attributes: JSON.stringify({ ...this.attributesValue, ...{ is_readable: val } }) });
			}
		},
		showAsText: {
			get() {
				return this.attributesValue.show_as_text;
			},
			set(val) {
				this.$emit("input", { ...this.value, attributes: JSON.stringify({ ...this.attributesValue, ...{ show_as_text: val } }) });
			}
		},
		attributesValue: {
			get() {
				const attributes = typeof this.value.attributes === "string" ? JSON.parse(this.value.attributes) : this.value.attributes;
				return attributes;
			},
			set(val) {
				this.$emit("input", { ...this.value, attributes: JSON.stringify(val) });
			}
		},
		filterNumnerFormFields() {
			return this.formFields.filter(field => (field.control === this.$constant.request.control.number || field.control === this.$constant.request.control.repeater) && field.id);
		},
		calculatorType: {
			get() {
				return this.attributesValue.type;
			},
			set(val) {
				this.$emit("input", { ...this.value, attributes: JSON.stringify({ ...this.attributesValue, ...{ type: val } }) });
			}
		}
	},
	watch: {
		isDialogActive(val) {
			if (!val) return;

			if (!this.value) {
				this.initValues();
			}
		},
		value: {
			handler: function() {
				this.isFormDirty = JSON.stringify(this.value) !== JSON.stringify(this.initFormData);
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			this.isFormDirty = false;
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onSubmit");
				}
			});
		},
		handleBeforeCloseDialog(setDialogHide) {
			this.handleCloseDialog(() => {
				this.initValues();
				setDialogHide();
			}, this.isFormDirty);
		},
		handleChangeControl(val) {
			const selectedControl = this.requestTypeControls.find(control => control.id === val);
			if (selectedControl) {
				this.$emit("input", { ...this.value, control: selectedControl.id, attributes: selectedControl.attributes });
			}
		}
	},
	created() {
		this.initFormData = _.cloneDeep(this.value);
	}
};
</script>
